import api from "../api/api"; // Importa a instância da API
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const funcionarioService = {
  // Lista todos os funcionários com detalhes completos
  async fetchFuncionarios() {
    try {
      const url = `${BASE_URL}/funcionarios`;
      const response = await api.get(url);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao obter os funcionários.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter os funcionários.");
    }
  },
  async fetchFuncionariosSimples() {
    try {
      const url = `${BASE_URL}/funcionarios-lista`;
      const response = await api.get(url);

      // Verifica o status e retorna os dados da resposta
      if (response.status === 200 && response.data) {
        return response.data;
      }
      throw new Error("Erro ao obter os dados dos funcionários.");
    } catch (error) {
      console.error("Erro ao buscar funcionários:", error);
      throw error; // Repassa o erro para ser tratado no componente
    }
  },


// Busca um funcionário específico por ID
async fetchFuncionarioPorId(id) {
  try {
    const url = `${BASE_URL}/funcionarios-id/${id}`; // Monta a URL da API
    const response = await api.get(url); // Faz a requisição GET
    if (response.status === 200 && response.data) {
      // Verifica se a resposta é bem-sucedida
      return response.data; // Retorna os dados do funcionário
    } else {
      throw new Error("Erro ao obter o funcionário."); // Lança erro se o status não for 200
    }
  } catch (error) {
    handleError(error, `Erro ao obter o funcionário com ID: ${id}`); // Trata o erro
    throw error; // Propaga o erro para que o chamador saiba que houve um problema
  }
},

  // Cria um novo funcionário
  async criarFuncionario(dados) {
    try {
      const url = `${BASE_URL}/funcionarios`;
      const response = await api.post(url, dados, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === 201 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao criar o funcionário.");
      }
    } catch (error) {
      handleError(error, "Erro ao criar o funcionário.");
    }
  },

  // Atualiza um funcionário existente
  async atualizarFuncionario(id, dados) {
    try {
      const url = `${BASE_URL}/funcionarios/${id}`;
      const response = await api.put(url, dados, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao atualizar o funcionário.");
      }
    } catch (error) {
      handleError(error, "Erro ao atualizar o funcionário.");
    }
  },

  // Exclui um funcionário por ID
  async excluirFuncionario(id) {
    try {
      const url = `${BASE_URL}/funcionarios/${id}`;
      const response = await api.delete(url);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Erro ao excluir o funcionário.");
      }
    } catch (error) {
      handleError(error, "Erro ao excluir o funcionário.");
    }
  },
};

// Função auxiliar para tratar erros
function handleError(error, mensagemPadrao) {
  if (error.response) {
    throw new Error(error.response.data.message || mensagemPadrao);
  } else if (error.request) {
    throw new Error("Erro de rede. Por favor, verifique sua conexão.");
  } else {
    throw new Error(error.message || mensagemPadrao);
  }
}
